import { numberWithCommas } from '../common/util';
import { UIDialog } from '../common/ui/uiDialog';
import { UIGrid } from '../common/ui/uiGrid';
import { UIPanel } from '../common/ui/uiPanel';
import { UIPanelButton } from '../common/ui/uiPanelButton';
import { UIText } from '../common/ui/uiText';
// import { Site } from 'src/site/site';
import { Game } from './game';
import { GameStyle } from './gameStyle';

export class TournamentResultsDialog extends UIDialog {
  protected titleText: UIText;
  protected gameScoresGrid: UIGrid;
  protected finalScoreText: UIText;

  public build() {
    let popup = new UIPanel({
      size : {x : 340, y : 355},
      anchor : {x : 0.5, y : 0.5},
      pivot : {x : 0.5, y : 0.5},
      radius: GameStyle.dialog.panel.radius,
      color: GameStyle.dialog.panel.color,
      gradient: GameStyle.dialog.panel.gradient,
      borderColor: GameStyle.dialog.panel.borderColor,
      borderWidth: GameStyle.dialog.panel.borderWidth,
      shadow: GameStyle.dialog.panel.shadow,
      parent : this
    });

    this.titleText = new UIText({
      text : 'Tournament Results',
      position : {x : 0, y : 12},
      anchor : {x : 0.5, y : 0},
      pivot : {x : 0.5, y : 0},
      color: GameStyle.dialog.title.color,
      fontFamily: GameStyle.dialog.title.fontFamily,
      fontSize: GameStyle.dialog.title.fontSize,
      fontWeight: GameStyle.dialog.title.fontWeight,
      shadow: GameStyle.dialog.title.shadow,
      parent : popup
    });

    let finalScorePanel = new UIPanel({
      fitParent: {left: 20, right: 20, top: -1, bottom: -1},
      position : {x : 0, y : 50},
      size : {x : 0, y : 40},
      color : GameStyle.dialog.field.panel.color,
      radius : GameStyle.dialog.field.panel.radius,
      parent : popup
    });

    let finalScoreLabel = new UIText({
      text : 'Total Score',
      position: {x: 10, y: 0},
      anchor: {x: 0, y: 0.5},
      pivot: {x: 0, y: 0.5},
      horizontalAlign: 'right',
      color : GameStyle.dialog.message.color,
      fontFamily : GameStyle.dialog.message.fontFamily,
      fontSize : GameStyle.dialog.message.fontSize,
      parent : finalScorePanel
    });

    this.finalScoreText = new UIText({
      text : '',
      position: {x: -10, y: 0},
      anchor: {x: 1, y: 0.5},
      pivot: {x: 1, y: 0.5},
      horizontalAlign: 'right',
      color : GameStyle.dialog.message.color,
      fontFamily : GameStyle.dialog.message.fontFamily,
      fontSize : GameStyle.dialog.message.fontSize,
      parent : finalScorePanel
    });

    let gameScoresLabel = new UIText({
      text : 'GAME SCORES',
      position : {x : 0, y : 105},
      anchor : {x : 0.5, y : 0},
      pivot : {x : 0.5, y : 0},
      color : GameStyle.dialog.message.color + '80',
      fontFamily : GameStyle.dialog.message.fontFamily,
      fontSize : GameStyle.dialog.message.fontSize,
      parent : popup
    });

    let gameScoresPanel = new UIPanel({
      fitParent: {left: 20, right: 20, top: -1, bottom: -1},
      position : {x : 0, y : 130},
      size : {x : 0, y : 145},
      mouseEvents : true,
      clipChildren : true,
      scrollChildren : {horizontal : false, vertical : true},
      color : GameStyle.dialog.field.panel.color,
      radius : GameStyle.dialog.field.panel.radius,
      parent : popup
    });

    this.gameScoresGrid = new UIGrid({
      columns: 1,
      rows: 1,
      fitParent: {left: 0, right: 0, top: -1, bottom: -1},
      size: {x: 0, y: 0},
      position: {x:0, y: 10},
      autoSizeChildren: true,
      parent: gameScoresPanel
    });

    let quitButton = new UIPanelButton({
      text : 'OK',
      anchor : {x : 0.5, y : 1},
      pivot : {x : 0.5, y : 1},
      size : {x : 120, y : 40},
      position : {x : 0, y : -20},
      callback : () => {
        this.onClose();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      textOffset: GameStyle.dialog.button.textOffset,
      borderColor: GameStyle.dialog.button.borderColor,
      borderWidth: GameStyle.dialog.button.borderWidth,
      parent : popup
    });
  }

  protected buildGameScores() {
    this.gameScoresGrid.deleteAllChildren();

    this.gameScoresGrid.rows = Game.instance.solitaire.tournamentGameScores.length + 1;
    this.gameScoresGrid.size.y = (this.gameScoresGrid.rows * 25);

    for(let i = 0; i < Game.instance.solitaire.tournamentGameScores.length; i++) {
      let panel = new UIPanel({
        parent : this.gameScoresGrid
      });

      let text = new UIText({
        text : 'Game ' + (i+1).toString(),
        position: {x: 10, y: 0},
        color : GameStyle.dialog.message.color,
        fontFamily : GameStyle.dialog.message.fontFamily,
        fontSize : GameStyle.dialog.message.fontSize,
        parent : panel
      });

      let score = new UIText({
        text : numberWithCommas(Game.instance.solitaire.tournamentGameScores[i]),
        position: {x: -10, y: 0},
        anchor: {x: 1, y: 0},
        pivot: {x: 1, y: 0},
        horizontalAlign: 'right',
        color : GameStyle.dialog.message.color,
        fontFamily : GameStyle.dialog.message.fontFamily,
        fontSize : GameStyle.dialog.message.fontSize,
        parent : panel
      });
    }

    let panel = new UIPanel({
      parent : this.gameScoresGrid
    });
  }

  public onWake() {
    super.onWake();
    this.finalScoreText.text = numberWithCommas(Game.instance.solitaire.tournamentTotalScore);
    this.buildGameScores();
  }

  protected onClose() {
    this.hide();

    // if(Site.room.isActive())
    //   Game.instance.showRoom();
    // else
      Game.instance.selectGameMode();
 }
}